import styled from 'styled-components';
import Box from '@mui/material/Box';

// Define a styled Box component
export const StyledBox = styled(Box)`
color: #000000;
font-size: 14px;
font-family: 'Noto Sans', sans-serif;
.MuiButtonBase-root{
    margin-right: 6px;
}
span.profilearrow{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
}
.profileBox{
    font-size: 40px;
}
.h5{
    font-size: 16px; 
                               @media screen and (min-device-width: 1098px) and (max-device-width: 1299px) { 
       font-size: 14px;
    }
                                   @media screen and (min-device-width: 900px) and (max-device-width: 1097px) { 
       font-size: 12px;
    }

}

`;

export const ProfileWrapper = styled.div`

`;

